module.exports = __webpack_public_path__ + "img/bbjw1.cbade9d1.jpg";